/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requireIdPorten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requireEmployeer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requireUserOrganizationInMinSide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    helpTextReasonField?: string | null;
}

/**
 * Check if a given object implements the PermissionResponse interface.
 */
export function instanceOfPermissionResponse(value: object): value is PermissionResponse {
    return true;
}

export function PermissionResponseFromJSON(json: any): PermissionResponse {
    return PermissionResponseFromJSONTyped(json, false);
}

export function PermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'requireIdPorten': json['requireIdPorten'] == null ? undefined : json['requireIdPorten'],
        'requireEmployeer': json['requireEmployeer'] == null ? undefined : json['requireEmployeer'],
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] == null ? undefined : json['requireUserOrganizationInMinSide'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function PermissionResponseToJSON(json: any): PermissionResponse {
    return PermissionResponseToJSONTyped(json, false);
}

export function PermissionResponseToJSONTyped(value?: PermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationName': value['applicationName'],
        'organizationGroupId': value['organizationGroupId'],
        'requireIdPorten': value['requireIdPorten'],
        'requireEmployeer': value['requireEmployeer'],
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'requiresMfa': value['requiresMfa'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

